import './App.css';
import RootRouter from '../router/router';

function App() {
  return (
    <RootRouter />
  );
}

export default App;
